import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import {
  UserActivityReportActions,
  UserActivityReportActionTypes,
} from './user-activity-report.actions';
import { UserActivityReportEntity } from './user-activity-report.model';

export type UserActivityReportEntities = EntityState<UserActivityReportEntity>;

export const adapter: EntityAdapter<UserActivityReportEntity> =
  createEntityAdapter<UserActivityReportEntity>({
    selectId: (entity) => `${entity.pilotId}${entity.entityId}`,
  });

export const initialState: UserActivityReportEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): UserActivityReportEntities {
  const action = incomingAction as UserActivityReportActions;
  switch (action.type) {
    case UserActivityReportActionTypes.AddUserActivityReport: {
      return adapter.addOne(action.payload.userActivityReport, state);
    }

    case UserActivityReportActionTypes.UpsertUserActivityReport: {
      return adapter.upsertOne(action.payload.userActivityReport, state);
    }

    case UserActivityReportActionTypes.AddUserActivityReports: {
      return adapter.addMany(action.payload.userActivityReports, state);
    }

    case UserActivityReportActionTypes.UpsertUserActivityReports: {
      return adapter.upsertMany(action.payload.userActivityReports, state);
    }

    case UserActivityReportActionTypes.UpdateUserActivityReport: {
      return adapter.updateOne(action.payload.userActivityReport, state);
    }

    case UserActivityReportActionTypes.UpdateUserActivityReports: {
      return adapter.updateMany(action.payload.userActivityReports, state);
    }

    case UserActivityReportActionTypes.DeleteUserActivityReport: {
      return adapter.removeOne(action.payload.id, state);
    }

    case UserActivityReportActionTypes.DeleteUserActivityReports: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case UserActivityReportActionTypes.LoadUserActivityReports: {
      return adapter.setAll(action.payload.userActivityReports, state);
    }

    case UserActivityReportActionTypes.ClearUserActivityReports: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
